module.exports = __webpack_public_path__ + "static/reatil-58cb0ef18f1a858cf49019305c00fd28.png";